import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class NativeNotificationService {

    constructor(private platform: Platform) {
        this.requestPermission();
    }

    async requestPermission() {
        if (!('Notification' in window)) {
            console.log('This browser does not support desktop notification');
            return false;
        }

        try {
            if (Notification.permission !== 'granted' && Notification.permission !== 'denied') {
                const permission = await Notification.requestPermission();
                return permission === 'granted';
            }

            return Notification.permission === 'granted';
        } catch (err) {
            console.warn('Unable to request notification permission:', err);
            return false;
        }
    }

    async showNotification(title: string, options: NotificationOptions = {}) {
        const hasPermission = await this.requestPermission();

        if (hasPermission) {
            // Platform specific icon/vibrate behavior
            const defaultOptions: any = {
                icon: '/assets/icon/favicon.png',
                badge: '/assets/icon/favicon.png',
                silent: false,
                vibrate: [200, 100, 200],
                ...options
            };

            try {
                if ('serviceWorker' in navigator) {
                    const registration = await navigator.serviceWorker.getRegistration();
                    if (registration && typeof registration.showNotification === 'function') {
                        await registration.showNotification(title, defaultOptions);
                        return;
                    }
                }

                const notification = new Notification(title, defaultOptions);
                notification.onclick = () => {
                    window.focus();
                    notification.close();
                };
            } catch (err) {
                console.warn('Native notification fallback failed:', err);
            }
        } else {
            console.warn('Notification permission not granted');
        }
    }
}
